import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-datepicker-row',
  templateUrl: './datepicker-row.component.html',
  styleUrl: './datepicker-row.component.scss'
})
export class DatepickerRowComponent {
  @Input({ required: true }) label: string;
  @Input({ required: true }) placeholder: string;
  @Input({ required: true }) errorMessage: string;
  @Input({ required: true }) control: FormControl;
  @Input({ required: false }) width = "30%";
  @Input({ required: false }) isResponsive = true;

  isInvalid(): boolean {
    const control = this.control;
    return control ? control.invalid && (control.dirty || control.touched) : false;
  }
}
